import { evalCondition, notifyParent } from 'mailup-react-helpers'
import { Link, LINK_VARIANT_HIGHLIGHT } from 'mailup-web-components'
import PropTypes from 'prop-types'

import { useIntl } from 'react-intl'
import { CASE_2 } from '../ModalSmsSender'

const LinkNewSmsAlias = ({ caseState }) => {
  const intl = useIntl()

  const handleRequestNew = () => {
    notifyParent('redirectMainFrame', [
      '/console/settings_app_redirector.aspx?r=/settings/smsalias/0'
    ])
  }

  return (
    caseState === CASE_2 &&
    evalCondition('co:SMSALIAS AND uo:SETTINGS') && (
      <Link
        variant={LINK_VARIANT_HIGHLIGHT}
        onClick={handleRequestNew}
        data-mu-test='modal-sms-sender-new-sms'
      >
        {intl.formatMessage({
          id: 'Load.SmsAliasSelector.ModalSenderLinkNewSmsAlias'
        })}
      </Link>
    )
  )
}

LinkNewSmsAlias.propTypes = {
  caseState: PropTypes.number
}

export default LinkNewSmsAlias
